<template>
  <v-container id="unsubscribe">
    <v-row justify="center">
      <v-col lg="9">
        <MaterialCard
          :title="this.$t('title.unsubscribe')"
          v-if="unsubscribe_data"
          color="primary"
          elevation="0"
        >
          <v-row class="ma-0">
            <v-col
              v-for="field in visibleCheckFields"
              :key="field.value"
              cols="12"
              md="6"
            >
              <v-checkbox
                v-model="unsubscribe_data[field.value]"
                color="primary"
                validate-on-blur
                :error="
                  fieldEqualsDisplay(field.id, 'required') &&
                    (unsubscribe_data[field.id] === false ||
                      unsubscribe_data[field.id] === null)
                "
                required
              >
                <template #label>
                  {{ $t(field.label) }}
                  <span
                    v-if="fieldEqualsDisplay(field.id, 'required')"
                    class="red--text"
                  >
                    <strong>* </strong>
                  </span>
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="12">
              <v-btn
                color="primary"
                class="no-text-transform display-1"
                type="submit"
                @click="saveUnsubscribe"
                >{{ this.$t("button.save") }}
              </v-btn>
            </v-col>
          </v-row>
        </MaterialCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MaterialCard from "@/components/views/MaterialCard";
import { registration } from "@/mixins/registration";

export default {
  name: "Unsubscribe",
  components: { MaterialCard },
  mixins: [registration],
  data() {
    return {
      unsubscribe_token: null,
      unsubscribe_data: null
    };
  },
  beforeCreate() {
    this.unsubscribe_token = this.$route.params.token;
    this.$store
      .dispatch("user/getDataForUnsubscribe", {
        token: this.unsubscribe_token
      })
      .then(response => {
        this.unsubscribe_data = response.data;
      })
      .catch(() => {
        this.$store.commit("viewstate/notify", {
          color: "error",
          text: this.$t("error.user_not_found_by_unsubscribe_token")
        });
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    saveUnsubscribe() {
      let data = this.unsubscribe_data;
      delete data.uuid;
      this.$store
        .dispatch("user/putUnsubscribeData", {
          token: this.$route.params.token,
          data: data
        })
        .then(() => {
          this.$store.commit("viewstate/notify", {
            color: "success",
            text: this.$t("success.saved_unsubscribe_data")
          });
        })
        .catch(() => {
          this.$store.commit("viewstate/notify", {
            color: "error",
            text: this.$t("error.user_not_found_by_unsubscribe_token")
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped></style>
